import { formatCpf } from './federal-tax-id'

export const removeExpecialCharactersFromCPF = (value: string) => {
  let formatValue = value.replace(/[.-]/g, '')
  formatValue = formatValue.replace(/\s+/g, '')

  return formatValue
}

function matchNumbers(value: string | number | number[]) {
  if (typeof value === 'string') {
    return (value.match(/\d/g) || []).map(Number)
  } else if (typeof value === 'number') {
    return value.toString().match(/\d/g)?.map(Number) || []
  } else if (Array.isArray(value)) {
    return value.filter((v) => typeof v === 'number' && v >= 0 && v <= 9)
  }
  return []
}

function validCalc(base: number, numbers: number[]) {
  const factors = Array.from({ length: base }, (_, i) => base + 1 - i)
  const sum = numbers.slice(0, base).reduce((acc, num, i) => acc + num * factors[i], 0)
  const result = (sum * 10) % 11
  return result === 10 ? 0 : result
}

export function isValidCPF(value: string | number | number[] = '') {
  if (!value) return false

  const isString = typeof value === 'string'
  const validTypes = isString || Number.isInteger(value) || Array.isArray(value)

  if (!validTypes) return false

  const numbers = matchNumbers(value)

  if (numbers.length !== 11) return false

  const items = [...new Set(numbers)]
  if (items.length === 1) return false

  const digits = numbers.slice(9)

  const digit0 = validCalc(9, numbers)
  if (digit0 !== digits[0]) return false

  const digit1 = validCalc(10, numbers)
  return digit1 === digits[1]
}

/**
 * Mantida pela assinatura antiga. Delega para `formatCpf`
 * (`utils/federal-tax-id`): 11 dígitos formatados, o resto como veio.
 * `validate` não tem mais efeito: devolver `xxx.xxx.xxx-xx` escondia o dado
 * e cortar o 12º dígito mostrava outro CPF. Para validar, use `isValidCPF`.
 */
export function formatCPF(value: string | number | number[] | null = '', _validate: boolean = true) {
  return formatCpf(Array.isArray(value) ? value.join('') : value)
}

/**
 * Formato de LEITURA do CPF (nome antigo, usado em dezenas de telas).
 * Delega para `formatCpf`. Em campo editável use `cpfInputMask`.
 */
export const cpfMask = (value: string | null | undefined) => formatCpf(value)

export function rgMask(value: string) {
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{2})(\d)/, '$1.$2')
    .replace(/^(\d{2})\.(\d{3})(\d)/, '$1.$2.$3')
    .replace(/^(\d{2})\.(\d{3})\.(\d{3})(\d)/, '$1.$2.$3-$4');
}

export function cepMask(value: string) {
  return value
    .replace(/\D/g, '')
    .replace(/^(\d{5})(\d)/, '$1-$2');
}
/**
 * Máscara de DIGITAÇÃO: formata parcial enquanto a pessoa escreve e para no
 * 11º dígito. Use só em `value` de campo editável. Para exibir um CPF que veio
 * do dado, use `formatCpf` (`utils/federal-tax-id`), que não mascara pela
 * metade nem corta dígitos.
 */
export const cpfInputMask = (value: string) => {
  return value
    .replace(/\D/g, '')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1')
}
